module.exports = __webpack_public_path__ + "static/media/QMIPeople.5ad9e7c3.gif";